// extracted by mini-css-extract-plugin
export default {"tableComponent":"styles_tableComponent__dUpps","tablePagination":"styles_tablePagination__v8Ie7"};